import {css} from '@emotion/css';
import {useMemo} from 'react';

const useStyle = () => {
    return useMemo(
        () => ({
            wrapper: css({
                zIndex: 1200,
                position: 'relative',
            }),
        }),
        []
    );
};

export default useStyle;
